// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '0.6.1 beta';
export const API_BASE_URL = '/api';
export const ENABLE_REDUX_LOGGER = false;

export default {};
